import { writable } from 'svelte/store';
import { storeUserEmpty } from './user';
export const storeArticles = writable([]);
export const storeArticlesError = writable("");
export const storeArticle = writable({});
export const storeMyArticles = writable([]);
export const storePartnerArticles = writable([]);
export const storeEmptyArticle = {
    id: 0,
    title_fr: "",
    title_en: "",
    subtitle_fr: "",
    subtitle_en: "",
    text_fr: "",
    text_en: "",
    photo: "",
    url_article: "",
    id_author: 0,
    date_publication: "",
    id_article_status: 0,
    rate: 0,
    category: "",
    author: storeUserEmpty,
};
